import { useQuery } from 'react-apollo';
import { useSelector } from 'react-redux';

import { getAccountQuery } from '../../../../apps/temp/graphql/queries/getAccount';
import { AlbumFolderWithPurchasableItems } from '../../../../graphql/queries/album-folder';

const useDiscoverAlbumFolderPrepaidItems = ({ albumFolderId }) => {
  const authenticated = useSelector(({ auth }) => auth.authenticated);
  const { data: { me: user } = {}, loading } = useQuery(getAccountQuery, {
    skip: !authenticated,
  });
  const { data: { albumFolder } = {} } = useQuery(
    AlbumFolderWithPurchasableItems,
    {
      variables: {
        id: albumFolderId,
      },
      skip: !albumFolderId,
    },
  );

  return {
    user,
    loading,
    activePromoCode: albumFolder?.active_promo_codes?.records?.[0],
  };
};

export default useDiscoverAlbumFolderPrepaidItems;
